import { AGENCY_LABEL_MAP, EAgencies } from "src/shared/types/common.types";

export function parseAgency(value: string | null): EAgencies | null {
  if (!value) return null;

  const n = Number(value);

  if (!Number.isFinite(n)) return null;

  return n in AGENCY_LABEL_MAP ? (n as EAgencies) : null;
}
